import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { StyledForm } from "../../../styled/form";
import { StyledPaper } from "../../../styled/paper";

const NotificacionBuscarFilters = ({ categories, categoria, onCategoriaChange, onSearch }) => {
    return (
        <StyledPaper.Container>
            <StyledForm.Input>
                <FormControl fullWidth>
                    <InputLabel id="categoria-search-label">Categoría</InputLabel>
                    <Select
                        labelId="categoria-search-label"
                        label="Categoria"
                        value={categoria}
                        onChange={(e) => onCategoriaChange(e.target.value)}
                        variant="standard"
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {categories.map((item) => (
                            <MenuItem key={item} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </StyledForm.Input>
            <StyledForm.ButtonContainer>
                <StyledForm.Button variant="contained" color="primary" onClick={onSearch}>
                    Buscar
                </StyledForm.Button>
            </StyledForm.ButtonContainer>
        </StyledPaper.Container>
    );
};

export default NotificacionBuscarFilters;
